import { faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { connect } from 'react-redux';
import { Button, ButtonGroup, Modal } from 'rsuite';
import { placeTypeActions } from '../../../../redux/actions';

const mapDispatchToProps = dispatch => ({
    closeDeleteModal: () => dispatch(placeTypeActions.closeDeleteModal()),
    delete: id => dispatch(placeTypeActions.remove(id)),
});

type Props = {
    delete: Function;
    placeTypeDrawer: Record<string, any>;
    delete_modal_openned: boolean;
    closeDeleteModal: Function;
} & WrappedComponentProps;

type State = {
    isRemoving: boolean;
};
class DeletePlaceTypeModal extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            isRemoving: false,
        };

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete() {
        this.setState({
            isRemoving: true,
        });
        this.props.delete(this.props.placeTypeDrawer.id);
        this.props.closeDeleteModal();
    }

    render() {
        if (this.props.placeTypeDrawer) {
            return (
                <Modal
                    size="xs"
                    show={this.props.delete_modal_openned}
                    onHide={() => this.props.closeDeleteModal()}
                    data-cy="placeType-deleteplaceType-modal">
                    <Modal.Header>
                        <Modal.Title>
                            <FormattedMessage id="placeType.delete.title" /> - {this.props.placeTypeDrawer.label}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body data-cy="placeType-delete-modal">
                        <FormattedMessage id="placeType.delete.message" />
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonGroup>
                            <Button
                                onClick={() => this.props.closeDeleteModal()}
                                data-cy="placeType-delete-modal-cancel"
                                color="red"
                                loading={this.state.isRemoving}>
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </Button>
                            <Button
                                onClick={this.handleDelete}
                                data-cy="placeType-delete-modal-valid"
                                appearance="primary"
                                loading={this.state.isRemoving}>
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                        </ButtonGroup>
                    </Modal.Footer>
                </Modal>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    let { delete_modal_openned, placeTypeDrawer } = state.placeTypes;

    return { delete_modal_openned, placeTypeDrawer };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DeletePlaceTypeModal));
